module.exports = __webpack_public_path__ + "fa-brands-400.svg?f74b8457fd9c2d3575629cf1584704aa";